import { Typography } from "@mui/material";
// Elrejtve a jövő évi rendezvényig - jövőre újra kell aktiválni
// import { Box } from "@mui/material";
// import CounterBox from "./counter/counter-box.component";
import { StyledWrapper } from "./hero-contents.styles";

const HeroContents = () => {
  return (
    <StyledWrapper>
      <Typography className="hero-title" component="h1">
        <span className="title-stroke">ECHOES</span>
        <span className="title-of">of the</span>
        <span className="title-solid">FUTURE</span>
      </Typography>

      {/* Elrejtve a jövő évi rendezvényig - jövőre újra kell aktiválni */}
      {/* <CounterBox /> */}

      {/* <Box className="cinema-pill">
        <span className="cinema-name">CINEMA CSÍKI MOZI</span>
        <span className="separator"> | </span>
        <span className="date-text">MAY 16, </span>
        <span className="date-year">2026</span>
      </Box> */}
    </StyledWrapper>
  );
};

export default HeroContents;
